module.exports = __webpack_public_path__ + "img/gc_country_flag_id.96265f40.svg";